module.exports = __webpack_public_path__ + "assets/img/catch-tank-view-of-surface-job.85fbf122.jpg";